import type { BaseSlideProps, ConceptTrioContent } from './SlideLayout.types';
import { inlineMarkdown } from '@/lib/markdown';

export function ConceptTrioSlide({ title, content, accentColor }: BaseSlideProps) {
  const { concepts } = content as ConceptTrioContent;

  return (
    <div
      className="slide-content animate-fade-in-up"
      style={{ '--color-accent': accentColor } as React.CSSProperties}
    >
      <h2 className="text-4xl font-serif font-bold mb-8 text-center accent-text">
        {title}
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {concepts.map((concept, idx) => (
          <div
            key={idx}
            className="concept-card animate-fade-in-up"
            style={{ animationDelay: `${idx * 0.1}s` }}
          >
            <div className="concept-label">{concept.label}</div>
            <p className="text-slate-700 dark:text-slate-300 mb-4 text-sm leading-relaxed"
               dangerouslySetInnerHTML={{ __html: inlineMarkdown(concept.description) }} />

            {concept.example && (
              <div className="mt-4 pt-4 border-t border-slate-200 dark:border-slate-700">
                <p className="text-xs font-medium text-slate-600 dark:text-slate-400 mb-2">
                  Example:
                </p>
                <p className="text-xs text-slate-600 dark:text-slate-400 italic"
                   dangerouslySetInnerHTML={{ __html: `"${inlineMarkdown(concept.example)}"` }} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
